/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserRoleType = 'Undefined' | 'SystemAdmin' | 'Reseller' | 'ResellerOfferManager' | 'ResellerSalesManager';

export const UserRoleType = {
    Undefined: 'Undefined' as UserRoleType,
    SystemAdmin: 'SystemAdmin' as UserRoleType,
    Reseller: 'Reseller' as UserRoleType,
    ResellerOfferManager: 'ResellerOfferManager' as UserRoleType,
    ResellerSalesManager: 'ResellerSalesManager' as UserRoleType
};

